//main.js
console.log("main.js loaded");

(() => {
  const selector = '[data-deferred-background-video]';

  function activateVideo(video) {
    if (video.dataset.videoActivated === 'true') return;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.dataset.videoActivated = 'true';
    video.load();

    const playPromise = video.play();
    if (playPromise) playPromise.catch(() => {});
  }

  function initDeferredBackgroundVideos(container = document) {
    container.querySelectorAll(selector).forEach((video) => {
      if (video.dataset.videoObserved === 'true') return;
      video.dataset.videoObserved = 'true';

      if (!('IntersectionObserver' in window)) {
        activateVideo(video);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          activateVideo(video);
          observer.disconnect();
        },
        { rootMargin: '400px 0px' }
      );

      observer.observe(video);
    });
  }

  initDeferredBackgroundVideos();

  document.addEventListener('shopify:section:load', (event) => {
    initDeferredBackgroundVideos(event.target);
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  const accordionTrigger = document.querySelector('[data-accordion-trigger="accordion-cart-notes"]');
  const accordionBody = document.getElementById('accordion-cart-notes');

  if (accordionTrigger && accordionBody) {
    accordionTrigger.addEventListener('click', function () {
      const isExpanded = accordionTrigger.getAttribute('aria-expanded') === 'true';

      accordionTrigger.setAttribute('aria-expanded', !isExpanded);
      accordionBody.style.display = isExpanded ? 'none' : 'block';
    });

    accordionTrigger.setAttribute('aria-expanded', 'false');
    accordionBody.style.display = 'none';
  }
});
$(document).ready(function () {
  $('.team-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.team-section .prev-btn'),
    nextArrow: $('.team-section .next-btn'),
    dots: false,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });

  // Add animation to team members on hover
  $('.team-member').hover(
    function () {
      $(this).css('transform', 'translateY(-10px)');
    },
    function () {
      $(this).css('transform', 'translateY(0)');
    }
  );

  // Animation observer
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
      }
    });
  }, observerOptions);

  document.querySelectorAll('.animate').forEach(el => {
    observer.observe(el);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Initialize Slick Carousel
  $('.events-carousel').slick({
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 3,
    focusOnSelect: true,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev'><svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='0.5' y='0.5' width='47' height='47' rx='4.5' stroke='#C6AD93'/><path d='M32 23H19.83L25.42 17.41L24 16L16 24L24 32L25.41 30.59L19.83 25H32V23Z' fill='#000'/></svg></button>",
    nextArrow: "<button type='button' class='slick-next'><svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'><rect x='0.5' y='0.5' width='47' height='47' rx='4.5' stroke='#C6AD93'/><path d='M24 16L22.59 17.41L28.17 23H16V25H28.17L22.59 30.59L24 32L32 24L24 16Z' fill='#000'/></svg></button>",
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerMode: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      }
    ]
  });

  // // Filter functionality
  // const filterButtons = document.querySelectorAll('.story-filters button');
  // const storyCards = document.querySelectorAll('.story-card');

  // filterButtons.forEach(button => {
  //   button.addEventListener('click', () => {
  //     const filter = button.dataset.filter;

  //     // Update active button
  //     filterButtons.forEach(btn => btn.classList.remove('active'));
  //     button.classList.add('active');

  //     // Filter cards
  //     storyCards.forEach(card => {
  //       const tags = card.dataset.tags ? card.dataset.tags.split(',') : [];

  //       if (filter === 'all' || tags.includes(filter)) {
  //         card.style.display = 'block';
  //       } else {
  //         card.style.display = 'none';
  //       }
  //     });
  //   });
  // });

  // Video popup
  $('.video-popup').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 300,
    preloader: true,
    fixedContentPos: true,
    iframe: {
      patterns: {
        youtube: {
          index: 'youtube.com/',
          id: function (url) {
            var match = url.match(/[?&]v=([^&]+)/);
            return match && match[1] ? match[1] : null;
          },
          src: 'https://www.youtube.com/embed/%id%?rel=0&modestbranding=1'
        }
      }
    }
  });


  // Modal functionality
  const modal = document.getElementById('story-upload-modal');
  const openBtn = document.getElementById('open-upload-modal');
  const closeBtn = document.querySelector('.close');

  if (openBtn) {
    openBtn.addEventListener('click', () => {
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    });
  }

  window.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  });



  $('.team-v3__grid').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    arrows: false,
    pauseOnHover: true,
    pauseOnFocus: true,
    draggable: true,
    swipe: true,
    touchMove: true,

    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 749,
        settings: {
          autoplaySpeed: 6000,
          slidesToShow: 1.1,
          arrows: true,
          centerMode: false,
          centerPadding: '0px'
        }
      }
    ]
  });


  $('.pdf-guides__mobile-only').slick({
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    arrows: true,
  });

  $('.ms-geo-banner__track').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    cssEase: 'linear',
    infinite: true,
    arrows: false,
    dots: false,
    variableWidth: true,


    draggable: false,
    swipe: false,
    touchMove: false,

    pauseOnHover: false,
    pauseOnFocus: false,
    accessibility: false,

    waitForAnimate: false,
    adaptiveHeight: false
  });



  var $heroSlider = $('.js-custom-hero-slider');
  var slideCount = $heroSlider.find('.custom-hero__slide').length;

  if (slideCount > 1) {
    $heroSlider.slick({
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 9000,
      fade: true,
      speed: 800,
      infinite: true,
      arrows: true,
      dots: false,
      adaptiveHeight: true,
      prevArrow: `<button class="slick-prev custom-hero__arrow" aria-label="Previous slide" type="button">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 12H18M18 12L13 7M18 12L13 17"
          stroke="#56504b" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>`,
      nextArrow: `<button class="slick-next custom-hero__arrow" aria-label="Next slide" type="button">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 12H18M18 12L13 7M18 12L13 17"
          stroke="#56504b" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>`,
      pauseOnHover: false,
      pauseOnFocus: false,
      draggable: false,
      swipe: true,
      touchMove: false,
      cssEase: 'ease-in-out',
      waitForAnimate: true
    });


    var $arrows = $heroSlider.find('.slick-prev, .slick-next');
    $('.custom-hero__arrows-container').append($arrows);
  }


});

document.addEventListener('DOMContentLoaded', () => {
  const panel = document.querySelector('.custom-popup__panel');
  const toggle = document.querySelector('.custom-popup__toggle');
  const close = document.querySelector('.custom-popup__close');

  if (!panel || !toggle || !close) return;


  requestAnimationFrame(() => {
    panel.classList.remove('is-closed');
    panel.classList.add('is-open');
  });

  const openPopup = () => {
    panel.classList.remove('is-closed');
    panel.classList.add('is-open');
  };

  const closePopup = () => {
    panel.classList.remove('is-open');
    panel.classList.add('is-closed');
  };

  toggle.addEventListener('click', openPopup);
  close.addEventListener('click', closePopup);
});


// Redirect Banner //
(function () {

  const MAIN_URL = "https://modernshelving.com/";
  const NYC_URL = "https://nyc.modernshelving.com/";

  const CACHE_KEY = "ms_geo_cache_v1";
  const DISMISS_KEY = "ms_geo_banner_dismissed_v1";

  const CACHE_TTL_MS = 24 * 60 * 60 * 1000;
  const DISMISS_TTL_MS = 30 * 24 * 60 * 60 * 1000;

  // Slide transition timing 
  const TRANSITION_MS = 260;

  const banner = document.getElementById("ms-geo-banner");
  if (!banner) return;

  const textEl = document.getElementById("ms-geo-banner__text");
  const ctaEl = document.getElementById("ms-geo-banner__cta");
  const dismissBtn = document.getElementById("ms-geo-banner__dismiss");
  if (!textEl || !ctaEl || !dismissBtn) return;

  function getHost(url) {
    try {
      return new URL(url).hostname.toLowerCase();
    } catch (e) {
      return "";
    }
  }

  const nycHost = getHost(NYC_URL);
  const currentHost = window.location.hostname.toLowerCase();
  const onNYC = currentHost === nycHost || currentHost.endsWith("." + nycHost);

  function getJSON(key) {
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function setJSON(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) { }
  }

  function isDismissed() {
    const d = getJSON(DISMISS_KEY);
    if (!d || !d.ts) return false;
    return (Date.now() - d.ts) < DISMISS_TTL_MS;
  }

  if (isDismissed()) return;

  // Dismiss: slide out, then hide
  dismissBtn.addEventListener("click", function () {
    setJSON(DISMISS_KEY, { ts: Date.now() });

    banner.classList.remove("is-visible");
    window.setTimeout(() => {
      banner.hidden = true;
    }, TRANSITION_MS);
  });

  // Show: unhide first, then add class next frame for transition
  function showBanner(message, href, label) {
    textEl.textContent = message;
    ctaEl.href = href;
    ctaEl.textContent = label;

    banner.hidden = false;

    requestAnimationFrame(() => {
      banner.classList.add("is-visible");
    });
  }

  function getCached() {
    const cached = getJSON(CACHE_KEY);
    if (!cached || !cached.ts) return null;
    if ((Date.now() - cached.ts) > CACHE_TTL_MS) return null;
    return cached;
  }

  function setCached(loc) {
    setJSON(CACHE_KEY, { ...loc, ts: Date.now() });
  }

  function decideAndMaybeShow(loc) {
    const country = (loc.country || "").toUpperCase();
    const region = (loc.region || loc.region_name || "").toLowerCase();

    const isNY = (country === "US" && region.includes("new york"));

    if (!onNYC && isNY) {
      showBanner(
        "It looks like you’re in New York. Want to view our NYC site?",
        NYC_URL,
        "Go to NYC site"
      );
      return;
    }

    if (onNYC && !isNY) {
      showBanner(
        "You’re on our NYC site. Want to switch to the main site?",
        MAIN_URL,
        "Go to main site"
      );
    }
  }

  async function fetchLocation() {
    const res = await fetch("https://ipapi.co/json/", { cache: "no-store" });
    if (!res.ok) throw new Error("geo failed");
    const data = await res.json();

    return {
      country: data.country,
      region: data.region,
      region_name: data.region
    };
  }

  (async function init() {
    const cached = getCached();
    if (cached) {
      decideAndMaybeShow(cached);
      return;
    }

    try {
      const loc = await fetchLocation();
      setCached(loc);
      decideAndMaybeShow(loc);
    } catch (e) {

    }
  })();
})();


// gsap banner //
// document.addEventListener('DOMContentLoaded', () => {
//   const slider = document.querySelector('.js-custom-hero-slider');
//   if (!slider) return;

//   let tl;

//   function animateActiveSlide() {
//     const activeSlide = slider.querySelector('.slick-current');
//     if (!activeSlide) return;

//     const banner = activeSlide.querySelector('.custom-hero__banner');
//     const contentItems = activeSlide.querySelectorAll('.custom-hero__content > *');
//     if (!banner) return;

//     if (tl) tl.kill();

//     gsap.set([banner, contentItems], { clearProps: "all" });
//     gsap.set(banner, { y: -50, autoAlpha: 0, force3D: true });
//     gsap.set(contentItems, { y: 30, autoAlpha: 0, force3D: true });

//     const bannerDuration = 1.2;   
//     const itemDuration = 0.55;   
//     const count = contentItems.length;


//     let stagger = 0;
//     if (count > 1) {
//       stagger = (bannerDuration - itemDuration) / (count - 1);

//       stagger = Math.max(0, stagger);
//     }

//     tl = gsap.timeline({ defaults: { ease: 'power3.out' } })
//       .to(banner, { y: 0, autoAlpha: 1, duration: bannerDuration, force3D: true })
//       .to(contentItems, {
//         y: 0,
//         autoAlpha: 1,
//         duration: itemDuration,
//         stagger,
//         force3D: true
//       }, 0);
//   }

//   if (slider.classList.contains('slick-initialized')) {
//     requestAnimationFrame(animateActiveSlide);
//   }

//   $(slider).on('init', function () {
//     requestAnimationFrame(animateActiveSlide);
//   });

//   $(slider).on('afterChange', function () {
//     requestAnimationFrame(animateActiveSlide);
//   });
// });





document.addEventListener("DOMContentLoaded", () => {
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  const sections = document.querySelectorAll(".column-cta-v3");
  if (!sections.length) return;

  sections.forEach((section) => {
    const orb = section.querySelector(".orbital-orb") || document.querySelector(".orbital-orb");
    const dots = gsap.utils.toArray(section.querySelectorAll(".orbital-orb__dot"));
    if (!dots.length) return;

    const phase = dots.map((_, i) => i * (360 / dots.length));
    const proxy = { p: 0, s: 0 };

    function getRadii() {
      const mobile = window.matchMedia("(max-width: 768px)").matches;
      if (!orb) return mobile ? [210, 235, 195] : [430, 470, 405];

      const orbR = orb.getBoundingClientRect().width / 2;
      const dotRs = dots.map(d => d.getBoundingClientRect().width / 2);
      const base = orbR + Math.max(...dotRs) / 2;

      const spread = mobile
        ? [0, 14, -12, 10, -8, 18, -14, 12]
        : [0, 22, -18, 14, -10, 26, -20, 16];

      return dots.map((_, i) => base + spread[i % spread.length]);
    }

    function render() {
      const radii = getRadii();
      const deg = proxy.s * 80;

      dots.forEach((dot, i) => {
        const a = (deg + phase[i]) * (Math.PI / 180);
        const r = radii[i] ?? radii[radii.length - 1];
        gsap.set(dot, { x: Math.cos(a) * r, y: Math.sin(a) * r });
      });
    }

    const st = ScrollTrigger.create({
      trigger: section,
      start: "top bottom",
      end: "bottom top",
      scrub: 8.0,
      onUpdate: (self) => {
        proxy.p = self.progress * 2;
        proxy.s += (proxy.p - proxy.s) * 0.9;
        render();
      }
    });

    render();

    const onResize = () => {
      render();
      ScrollTrigger.refresh();
    };
    window.addEventListener("resize", onResize);

    section._orbitalCleanup = () => {
      window.removeEventListener("resize", onResize);
      st.kill();
    };
  });
});


function initReveals(scope = document) {

  scope.querySelectorAll(".reveal-on-page-load").forEach((el) => {
    if (el.dataset.revealInit === "1") return;
    el.dataset.revealInit = "1";
    setTimeout(() => el.classList.add("active"), 50);
  });


  const observer1 = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.6 }
  );

  scope.querySelectorAll(".reveal-on-scroll").forEach((el) => {
    if (el.dataset.revealInit === "1") return;
    el.dataset.revealInit = "1";
    observer1.observe(el);
  });


  const observer2 = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );

  scope.querySelectorAll(".reveal-on-scroll-2").forEach((el) => {
    if (el.dataset.revealInit === "1") return;
    el.dataset.revealInit = "1";
    observer2.observe(el);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initReveals(document);
});


document.addEventListener("shopify:section:load", (e) => {
  initReveals(e.target);
});

document.addEventListener("shopify:section:select", (e) => {
  initReveals(e.target);
});

document.addEventListener("shopify:block:select", (e) => {
  initReveals(e.target.closest(".shopify-section") || document);
});



//tabs section//
(() => {
  const roots = document.querySelectorAll('[data-ms-retail-tabs]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('.ms-retail-tabs__tab'));
    const panels = Array.from(root.querySelectorAll('.ms-retail-tabs__panel'));
    const tablist = root.querySelector('[role="tablist"]');
    const scrollTarget = root.querySelector('.ms-retail-tabs__nav-wrap') || root;

    if (!tabs.length || !panels.length) return;

    const scrollToTabs = () => {
      const headerOffset = 120;
      const targetTop = scrollTarget.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    };

    const activate = (panelId, focusTab = false, shouldScroll = false) => {
      tabs.forEach((t) => {
        const isActive = t.getAttribute('data-ms-tab') === panelId;
        t.classList.toggle('ms-retail-tabs__tab--active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.setAttribute('tabindex', isActive ? '0' : '-1');
        if (isActive && focusTab) t.focus();
      });

      panels.forEach((p) => {
        const isActive = p.id === panelId;

        if (isActive) {
          p.classList.add('ms-retail-tabs__panel--active');
          p.removeAttribute('hidden');

          p.classList.remove('ms-retail-tabs__panel--enter');
          void p.offsetWidth;
          p.classList.add('ms-retail-tabs__panel--enter');
        } else {
          p.classList.remove('ms-retail-tabs__panel--enter');
          p.classList.remove('ms-retail-tabs__panel--active');
          p.setAttribute('hidden', '');
        }
      });

      if (shouldScroll) {
        scrollToTabs();
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activate(tab.getAttribute('data-ms-tab'), false, true);
      });
    });

    if (tablist) {
      tablist.addEventListener('keydown', (e) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;

        const currentIndex = tabs.findIndex((t) => t.classList.contains('ms-retail-tabs__tab--active'));
        if (currentIndex < 0) return;

        e.preventDefault();

        let nextIndex = currentIndex;

        if (e.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        if (e.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') nextIndex = 0;
        if (e.key === 'End') nextIndex = tabs.length - 1;

        activate(tabs[nextIndex].getAttribute('data-ms-tab'), true, true);
      });
    }

    const activeTab = tabs.find((t) => t.classList.contains('ms-retail-tabs__tab--active')) || tabs[0];
    if (activeTab) activate(activeTab.getAttribute('data-ms-tab'));
  });
})();

// Custom tabs section 2 //
(() => {
  const SECTION_SELECTOR = '[data-customer-stories-tabs]';

  function initTabs(section) {
    if (!section || section.dataset.tabsInitialized === 'true') return;

    const tablist = section.querySelector('[role="tablist"]');
    const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
    const panels = tabs.map((tab) => {
      const panelId = tab.getAttribute('aria-controls');
      return panelId ? document.getElementById(panelId) : null;
    });
    const line = section.querySelector('.customer-stories-tabs__line');

    if (!tablist || !tabs.length || !panels.length) return;

    section.dataset.tabsInitialized = 'true';

    function getActiveTab() {
      return (
        tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ||
        tabs[0]
      );
    }

    function updateLine(activeTab) {
      if (!line || !tablist || !activeTab) return;

      const tabRect = activeTab.getBoundingClientRect();
      const listRect = tablist.getBoundingClientRect();

      line.style.width = `${tabRect.width}px`;
      line.style.transform = `translateX(${
        tabRect.left - listRect.left + tablist.scrollLeft
      }px)`;
    }

    function activateTab(selectedTab, shouldFocus = false) {
      tabs.forEach((tab, index) => {
        const isSelected = tab === selectedTab;
        const panel = panels[index];

        tab.classList.toggle('is-active', isSelected);
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');

        if (panel) {
          panel.hidden = !isSelected;
          panel.classList.toggle('is-active', isSelected);
        }
      });

      updateLine(selectedTab);

      if (shouldFocus) {
        selectedTab.focus();
      }
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activateTab(tab, false);
      });

      tab.addEventListener('keydown', (event) => {
        const currentIndex = tabs.indexOf(document.activeElement);
        let nextIndex = null;

        switch (event.key) {
          case 'ArrowRight':
            nextIndex = (currentIndex + 1) % tabs.length;
            break;
          case 'ArrowLeft':
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        activateTab(tabs[nextIndex], true);
      });
    });

    const initialTab = getActiveTab();
    activateTab(initialTab, false);

    window.addEventListener('resize', () => {
      updateLine(getActiveTab());
    });

    tablist.addEventListener('scroll', () => {
      updateLine(getActiveTab());
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        updateLine(getActiveTab());
      });
    }

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => {
        updateLine(getActiveTab());
      });

      resizeObserver.observe(tablist);
      tabs.forEach((tab) => resizeObserver.observe(tab));
    }
  }

  function initAllTabs(container = document) {
    container.querySelectorAll(SECTION_SELECTOR).forEach(initTabs);
  }

  initAllTabs();

  document.addEventListener('shopify:section:load', (event) => {
    initAllTabs(event.target);
  });
})();
